var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarnaDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5985 5.68536L8.77615 8.50773L11.575 11.3066C11.8102 11.5183 11.8102 11.8711 11.575 12.0827C11.3633 12.3179 11.0105 12.3179 10.7988 12.0827L7.97648 9.28388L5.17763 12.0827C4.96595 12.3179 4.61316 12.3179 4.40148 12.0827C4.16628 11.8711 4.16628 11.5183 4.40148 11.2831L7.20033 8.48421L4.40148 5.68536C4.16628 5.47368 4.16628 5.12089 4.40148 4.88569C4.61316 4.67401 4.96595 4.67401 5.20115 4.88569L8 7.70806L10.7988 4.90921C11.0105 4.67401 11.3633 4.67401 11.5985 4.90921C11.8102 5.12089 11.8102 5.47368 11.5985 5.68536Z",
    fill: "#F87171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarnaDelete);
export default __webpack_public_path__ + "static/media/BarnaDelete.3cfa674a3a3c6eca593e886af072796a.svg";
export { ForwardRef as ReactComponent };